module.exports = __webpack_public_path__ + "media/images/promotion_screens_2-8d3f1ab5c1205612ec66678ec331e579.png";